export default __webpack_public_path__ + "static/media/img-slider-pikul-1.79dfcaa6.png";